/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_Meetings_ButtonInputs */

const en_company_jobs_meetings_button = /** @type {(inputs: Company_Jobs_Meetings_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule interviews`)
};

const de_company_jobs_meetings_button = /** @type {(inputs: Company_Jobs_Meetings_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprächstermine anlegen`)
};

/**
* | output |
* | --- |
* | "Schedule interviews" |
*
* @param {Company_Jobs_Meetings_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_meetings_button = /** @type {((inputs?: Company_Jobs_Meetings_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_Meetings_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_meetings_button(inputs)
	return en_company_jobs_meetings_button(inputs)
});